import type { FaceState } from '@/state/types';

export interface FaceGlyphs {
  eyes: string;
  mouth: string;
}

/**
 * Each face is rendered as two lines, both 13 characters wide so the mouth
 * centres below the eyes in a monospace font. Whitespace is preserved as-is.
 */
export const FACE_GLYPHS: Record<FaceState, FaceGlyphs> = {
  DEFAULT: { eyes: '( o )   ( o )', mouth: '   -------   ' },
  CONDESCENDING: { eyes: '( - )   ( o )', mouth: '      /      ' },
  SPIRAL: { eyes: '( # )   ( # )', mouth: '   vvvvvvv   ' },
  SHAME: { eyes: '( . )   ( . )', mouth: '      u      ' },
  SURPRISED: { eyes: '( O )   ( O )', mouth: '      O      ' },
  VOID: { eyes: '             ', mouth: '             ' },
};

export const GLITCH_CHARS = '$%#@' as const;
